
import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  /** Force light or dark variant. If not set, auto-detects from theme */
  variant?: 'light' | 'dark';
}

const Logo: React.FC<LogoProps> = ({
  size = 'md',
  className = '',
  variant
}) => {
  const { resolvedTheme } = useTheme();
  const isDark = variant === 'dark' || (!variant && resolvedTheme === 'dark');

  const heightClasses = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-14',
    xl: 'h-20'
  };

  const logoSrc = isDark ? '/darkmodelogo.png' : '/drillpoint logo.png';

  return (
    <img
      src={logoSrc}
      alt="DrillPoint - Borehole Mapping Solutions"
      className={`${heightClasses[size]} w-auto ${className}`}
    />
  );
};

export default Logo;
